import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { AdminapiService } from 'src/app/shared/services/adminapi.service';
import { AppState } from 'src/app/store/app.states';
import { getAdminUserInfo } from 'src/app/store/selector/selector';

declare var bootstrap: any;
declare var $: any;  

@Component({
  selector: 'app-admin-new-subscription',
  templateUrl: './new-subscription.component.html',
  styleUrls: ['./new-subscription.component.scss']
})
export class NewSubscriptionComponent implements OnInit {
  @Input() modalid:any;
  @Output() newItemEvent = new EventEmitter<string>();
  submitting=false;
  user:any
  allusers=[];
  subscriptions={};
  data = [{ skill: ''}]
  Form: FormGroup = this.fb.group({
    user_id: ["",Validators.compose([Validators.required])],
    subscription_code: ["",Validators.compose([Validators.required])]
  }); 

  constructor(private fb: FormBuilder,private store: Store<AppState>, private toastrService: ToastrService, public adminApi: AdminapiService) {
  }

  ngOnInit()  
  {    
    setTimeout(()=>{
      this.getUserData()
      this.getCategoryFormData()
    },500)
    $(document).ready(() => {   
        setTimeout( ()=> { 
          const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
           $('.selectpicker').selectpicker({ virtualScroll: (isFirefox)? false:600 }).selectpicker('refresh');
        }, 500); 
    });  
  } 

  addNewItem(value: string) {
    this.newItemEvent.emit(value);
  }

  userRoleMatch(role,user){
    let filtered = [];
    if(user && user!=""){
      filtered = this.allusers.filter(a => a.id == user)
    }
    if(filtered.length>0){
      return filtered[0].role==role
    }
    return false;
  }

  changeUser(){
    setTimeout(()=>{
      const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
      $('.selectpicker').selectpicker({ virtualScroll: (isFirefox)? false:600 }).selectpicker('refresh');
    },500)
  }

  getUserData(){
    this.store.pipe(select(getAdminUserInfo)).subscribe(data=>{
      this.user = data
    },error=>{
      this.toastrService.error("unable to handle response");
    })
  }
  
  getCategoryFormData(){
    this.adminApi.setLoader(true)
    this.adminApi.getSubscriptionFormData().subscribe((data: any) => {
      this.allusers=data.users
      this.subscriptions=data.subscriptions
      setTimeout( ()=> { 
        const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
        $('.selectpicker').selectpicker({ virtualScroll: (isFirefox)? false:600 }).selectpicker('refresh');
      }, 600); 
      this.adminApi.setLoader(false)
    },error=>{
      this.adminApi.setLoader(false)
      this.toastrService.error("unable to handle response");
    })
  }

  initForm(){
    this.Form = this.fb.group({
      user_id: ["",Validators.compose([Validators.required])],
      subscription_code: ["",Validators.compose([Validators.required])]
    });

    setTimeout( ()=> { 
      const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
      $('.selectpicker').selectpicker({ virtualScroll: (isFirefox)? false:600 }).selectpicker('refresh');
    }, 100); 
  }

  onSubmit(form: FormGroup) {
    if (form.valid && !this.submitting) {
      this.submitting = true;
      this.adminApi.addSubscription(form.value).subscribe((data: any) => {
        if (data.success) {
          this.addNewItem('change')
            form.reset();
            const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
            $('.selectpicker').selectpicker({ virtualScroll: (isFirefox)? false:600 }).selectpicker('refresh');
					this.toastrService.success(data.message);
          $('#'+this.modalid).modal('hide');
          //this.webApi.setSession(data);
          //this.router.navigateByUrl('/');
        } else {
					this.toastrService.error(data.message);
        }
        this.submitting = false;
      },
      error => {
        this.toastrService.error("unable to handle response");
        this.submitting=false;
      });
    } else {
      form.markAllAsTouched();
    }
  }

  get f2(): { [key: string]: AbstractControl } {
    return this.Form.controls;
  }
  
}
